import { render, staticRenderFns } from "./CatalogShop.vue?vue&type=template&id=32770874&"
import script from "./CatalogShop.vue?vue&type=script&lang=js&"
export * from "./CatalogShop.vue?vue&type=script&lang=js&"
import style0 from "./CatalogShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports